module.exports = __webpack_public_path__ + "img/denmark-ill-defined-causes-female.8f9a40e6.png";